import { show } from '../../core/alerts';
import { alertText as say } from '../../core/copy';

/**
 * What the plans door says that is its own: the refusal of a book owner's proof,
 * and a checkout that could not be opened.
 *
 * Nothing here is about approval, because nobody approves a purchase. The book
 * plan is free to whoever owns the book, so it asks for evidence, the last word on
 * a given page, and this is what a wrong one gets.
 *
 * The body is the server's own sentence, which carries the page and the attempts
 * left. Only the frame around it is chosen here, and the fallback for a request
 * that never reached an answer at all.
 *
 * Sentences about a shared step (a failed post, a refused sign-in) are in
 * core/alerts and are the same on every door.
 */

/** The word on that page of the book does not match. */
export function wrongKeyword(message) {
    show({
        icon: 'warning',
        title: say('wrong_keyword_title', 'Oops! Wrong Keyword'),
        text: message || say('generic_error', 'An error occurred. Please try again.'),
        confirmButtonText: say('try_again', 'Try Again')
    });
}

/**
 * The session was refused or Stripe did not answer. Generic on purpose: the reason
 * is logged on the server and is nothing the buyer can act on.
 */
export function checkoutFailed() {
    show({
        icon: 'error',
        title: say('checkout_failed_title', 'Checkout Unavailable'),
        text: say('checkout_failed_text', "We couldn't open the checkout right now. Please try again later."),
        confirmButtonText: say('close', 'Close')
    });
}
